import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import type { CommunityCurrentUsageStats } from "@/react/components/SettingsApp/Workflows/generated/WorkflowsApi.types";
import { useCommunityCurrentUsageStats } from "@/react/components/shared/Workflows/hooks/useCommunityCurrentUsageStats";
import type { PlanTiers } from "@/react/helpers/planHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { UPGRADE_PATHS } from "@circle-react-shared/UpgradePlan/constants";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { useUpgradePlanContext } from "./UpgradePlanContext";

const i18nRoot = "pricing_plans.upgrade_modal";

interface CheckIfPlanStatusSyncedWorkflowsAppProps {
  planTier?: PlanTiers;
}

export const CheckIfPlanStatusSyncedWorkflowsApp = ({
  planTier,
}: CheckIfPlanStatusSyncedWorkflowsAppProps) => {
  const history = useHistory();
  const { isEmailHubRequired } = useUpgradePlanContext();

  const checkUpgradeStatus = (response: CommunityCurrentUsageStats) => {
    const {
      plan_tier: responsePlanTier,
      marketing_hub_enabled: isEmailHubEnabled,
    } = response;

    const shouldCheckOnlyEmailHub = !planTier && isEmailHubRequired;
    const isPlanTierMatched = responsePlanTier === planTier;
    const isEmailHubValid = !isEmailHubRequired || isEmailHubEnabled;

    const isUpgradeSuccessful =
      (shouldCheckOnlyEmailHub && isEmailHubEnabled) ||
      (isPlanTierMatched && isEmailHubValid);

    if (isUpgradeSuccessful) {
      history.push(UPGRADE_PATHS.UPGRADE_SUCCESSFUL);
    }
  };

  useCommunityCurrentUsageStats({
    refetchInterval: 5000,
    onSuccess: (response: CommunityCurrentUsageStats) =>
      checkUpgradeStatus(response),
  });

  return (
    <Modal.Body>
      <div className="mt-28 text-center">
        <div className="m-auto mb-9 w-28">
          <Icon className="text-dark !h-full !w-full" type="loader" />
        </div>

        <div className="mb-28">
          <Typography.TitleLg color="text-darkest !font-bold">
            {t([i18nRoot, "loading.workflow_app_syncing"])}
          </Typography.TitleLg>
        </div>
      </div>
    </Modal.Body>
  );
};
